import React, { useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import HotelDetailsSection from "../../../templates/HotelPage/helperComponents/HotelDetailsSection/HotelDetailsSection";
import { useWebFramed } from "../../../hooks/useWebFramed";
import { useLocation } from "@reach/router";
import { layoutWrapper } from "../../global/Layout/Layout.module.scss";
import { fullScreenModal } from "./MetaHotelDetails.module.scss";
import {
  toggleButton,
  toggleIcon,
} from "../HotelSummary/HotelSummary.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useHotels } from "../../../hooks/useHotels";

type Feature = {
  field_feature_description: {
    value: string;
  };
  tab_title: string;
  field_feature_tab_title: string;
  description: string;
};

type Props = {
  hotel: {
    crs_code: any;
    relationships: any;
    features: Feature[] | null;
  };
};

const MetaHotelDetails: React.FC<Props> = ({ hotel }) => {
  const allHotels = useHotels();
  const matchingHotel = allHotels.find(
    (hotelInfo: any) => hotel.crs_code === hotelInfo.crs_code
  );
  const features = matchingHotel?.relationships?.hotelFeatures;
  const isWebFramed = useWebFramed();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  const { aboutText, renderedFeatures } = useMemo(() => {
    let about = "";
    const rendered: Feature[] = [];

    if (features && features.length > 0) {
      features.forEach((feature: any) => {
        const tabKey = feature.field_feature_tab_title.toLowerCase().trim();
        if (tabKey === "about") {
          about = feature.field_feature_description?.value;
        } else {
          rendered.push(feature);
        }
      });
    }
    return { aboutText: about, renderedFeatures: rendered };
  }, [features]);

  const toggleModal = () => setShowModal((prev) => !prev);

  return (
    <>
      <button
        onClick={toggleModal}
        className={`${toggleButton}`}
        style={{
          margin: "10px 0px 0px 0px",
        }}
        aria-label="Open hotel details"
        aria-expanded="false"
        aria-controls="hotel-details-modal"
      >
        <span className={`${toggleButton}`}>
          Hotel Details
          <span className={`${toggleIcon}`}>
            <FontAwesomeIcon
              className="fa-w-10"
              style={{ pointerEvents: "none" }}
              icon={faPlus}
            />
          </span>
        </span>
      </button>
      <Modal
        show={showModal}
        size="xl"
        className={`${layoutWrapper} ${fullScreenModal}`}
        centered
        aria-label="Hotel details modal"
      >
        <Modal.Body>
          <HotelDetailsSection
            features={features}
            renderedFeatures={renderedFeatures}
            isWebFramed={isWebFramed}
            hotel={hotel}
            location={location}
            isMetaHotelDetails
            handleCloseModal={toggleModal}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MetaHotelDetails;
